<template>
  <div
    style="min-height: calc(100vh - 70px);display: flex; justify-content: center; align-items: center"
  >
    <section class="m-content m-content-full align-items-center contact-us">
      <div class="gate_center col">
        <div class="row justify-content-center">
          <div class="col-xl-7 col-lg-10 col-md-11 col-xs-12 col-sm-12">
            <div class="widget">
              <div class="widget__body">
                <h2 class="text-center">Say Hello To Us!</h2>
                <div class="row m--margin-top-40">
                  <div class="col-sm-6 col-xs-12">
                    <i class="icon fa fa-phone"></i>
                    <div class="items">
                      <a href="tel:016311215">01-631-1215</a>
                      <a href="tel:014609945">01-460-9945</a>
                      <a href="tel:017008460">01-700-8460</a>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <i class="icon fa fa-envelope"></i>
                    <div class="items">
                      <a target="_blank" href="mailto:customer@getcarbon.co">customer@getcarbon.co</a>
                    </div>
                  </div>
                </div>
                <div class="row m--margin-top-40">
                  <div class="col-sm-6 col-xs-12">
                    <i class="icon fa fa-facebook"></i>
                    <div class="items">
                      <a target="_blank" href="https://facebook.com/getcarbon">getcarbon</a>
                    </div>
                  </div>
                  <div class="col-sm-6 col-xs-12">
                    <i class="icon fa fa-twitter"></i>
                    <div class="items">
                      <a target="_blank" href="https://twitter.com/get_carbon">@get_carbon</a>
                    </div>
                  </div>
                </div>
                <div class="row m--margin-top-40">
                  <div class="col-sm-6 col-xs-12">
                    <i class="icon fa fa-instagram"></i>
                    <div class="items">
                      <a target="_blank" href="https://instagram.com/getcarbon">@getcarbon</a>
                    </div>
                  </div>
                </div>
                <div class="m--margin-top-40 m--margin-bottom-10">
                  <div class="row justify-content-center">
                    <router-link
                      :to="{ name: 'wallet' }"
                      class="col-12 col-md-11 col-lg-10 btn m-btn--square btn-block btn-primary btn-lg m-btn wizard-next"
                    >OK</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import vue from "vue";
export default {
  data: () => ({}),
  components: {},
  mounted() {},
  methods: {}
};
</script>
<style>
.icon {
  font-size: 26px;
  color: #4301c2;
  display: inline-block;
  vertical-align: middle;
}
.items {
  display: inline-table;
  margin-left: 20px;
}
.items a {
  color: #3a3a3a;
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}
@media screen and (max-width: 632px) {
  h2 {
    font-size: 20px;
  }
  .items a {
    font-size: 12px;
  }
  .icon {
    font-size: 14px;
    display: inline-block;
  }
}
</style>
